import $ from 'jquery';
import masonry from 'masonry-layout';
import { gsap, Power2 } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import ModalVideo from 'modal-video'
gsap.registerPlugin(ScrollTrigger)

export const overlayMenu = () => {
    const elements = [
      '.nav__toogle',
      'body'
    ]
    const c = 'overlay-open'
    const d = 'after-hero'
    const h = $(window).height()/1.29 - 90;

    $(elements[0]).on('click', () =>
      $(elements.join(', ')).toggleClass(c)
    )

    $(window).scroll(() => {
        $(window).scrollTop() > h && $(elements.join(', ')).addClass(d)
        $(window).scrollTop() <= h && $(elements.join(', ')).removeClass(d)
    }
  )
}

export const loader = () => {
  $('#loader').fadeOut(900);
}

/* SETUP MODALVIDEO
  ----------------------------- */
export const setupModalVideo = () => {
  if ($('.js-modal-btn').length > 0 || $('.js-modal-btn-vimeo').length > 0) {
    new ModalVideo('.js-modal-btn')
    new ModalVideo('.js-modal-btn-vimeo', { channel: 'vimeo' })
  }
}




export const gridHeight = () => {
  const gridItems = $('.grid-item').toArray();
  gridItems.sort((a, b) => $(b).outerHeight() - $(a).outerHeight());
  const highestItems = gridItems.slice(0, 3);
  const totalHeight = highestItems.reduce((acc, item) => acc + $(item).outerHeight(), 0);
  const finalHeight = totalHeight + 100;
  $('.grid').css('height', finalHeight + 'px');
};

export const flexDirection = () => {
  $(document).on('facetwp-loaded', function () {
    const totalItems = $('.grid-item').length;

    if (totalItems <= 3) {
      $('.grid').css('flex-direction', 'row');
    } else {
      $('.grid').css('flex-direction', 'column');
    }
  });
};




/* SETUP VERTICAL LIST
  ----------------------------- */
export const setupVerticalList = () => {
  $(function () {
    let currentIndex = 1;

    // Initial setup
    setActive(currentIndex.toString());

    // Timer function
    setInterval(() => {
      currentIndex = currentIndex % $('.section__category-item-wrapper').length + 1;
      setActive(currentIndex.toString());
    }, 3000);

    function setActive(dataItem) {
      $('.section__category-item-wrapper').removeClass('active');
      $('.section__detail').removeClass('active');

      const clickedItem = $(`.section__category-item-wrapper[data-index="${dataItem}"]`);
      clickedItem.addClass('active');
      
      const detailItem = $(`.section__detail.section__detail--${clickedItem.attr('data-item')}`);
      detailItem.addClass('active');
    }
  });
}
